import script from "./index.vue?vue&type=script&lang=tsx&setup=true"
export * from "./index.vue?vue&type=script&lang=tsx&setup=true"

import "./index.vue?vue&type=style&index=0&id=a8b6a694&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8b6a694"]])

export default __exports__